/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated';
import { compareDependencies } from './dependenciesCompare.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { partitionSelectDependencies } from './dependenciesPartitionSelect.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createQuantileSeq } from '../../factoriesAny.js';
export var quantileSeqDependencies = {
  addDependencies: addDependencies,
  compareDependencies: compareDependencies,
  multiplyDependencies: multiplyDependencies,
  partitionSelectDependencies: partitionSelectDependencies,
  typedDependencies: typedDependencies,
  createQuantileSeq: createQuantileSeq
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesQuantileSeq.generated.js
// module id = 1623
// module chunks = 0